import React from "react";
import { useSelector } from "react-redux";
import { Alert } from "antd";
import Marquee from "react-fast-marquee";

const ScrollBar = () => {
  const information = useSelector(
    (state) => state?.globleSlice?.broadCastExpiry
  );
  const notification = useSelector(
    (state) => state?.globleSlice?.notification?.marque
  );

  const marqueMessage = notification?.reduce((acc, curr, index) => {
    acc += `${curr?.message} ${index === notification?.length - 1 ? "" : "|"} `;
    return acc;
  }, " ");

  const fullMessage = marqueMessage?.length > 0 ? marqueMessage : information;

  if (!fullMessage) return null;

  return (
    <Alert
      
      banner
      showIcon={false}
      message={
        <Marquee
          gradient={false}
          speed={130}
          style={{ color: "red" }}
        >
          {fullMessage}
        </Marquee>
      }
    />
  );
};

export default React.memo(ScrollBar);
